import { ColumnEditor } from 'LookupEditor/ColumnEditors/Base/ColumnEditor';

export class IconColumnEditor extends ColumnEditor {
    Show(): void {}

    ToString() {
        return 'Icon';
    }
}
